import { useTranslate } from "@refinedev/core";
import { SceneEnableSwitch } from "./SceneEnableSwitch";

export type PerChapterTransitionSwitchProps = {
  chapterNumber: number;
  /**
   * Word used in the tooltip ("Enable transition for Scene N" vs "...Chapter N").
   * Matches the user-facing label of the row this switch sits on, which is
   * inverted from the board type: Custom boards label rows as "Scene"; Flash
   * boards label them as "Chapter". It's a label choice, not a structural one.
   */
  labelAs: "scene" | "chapter";
  checked: boolean;
  onChange: (checked: boolean) => void;
};

export const PerChapterTransitionSwitch = ({
  chapterNumber,
  labelAs,
  checked,
  onChange,
}: PerChapterTransitionSwitchProps) => {
  const t = useTranslate();

  const suffix = labelAs === "scene" ? "Scene" : "Chapter";
  const action = checked ? "disable" : "enable";
  const key = `components.templates.TemplatesBoard.storyboardSlidesThumbnails.${action}TransitionFor${suffix}`;

  return (
    <SceneEnableSwitch
      checked={checked}
      onChange={onChange}
      tooltipTitle={t(key, { number: chapterNumber })}
    />
  );
};
